import getReduxSelector from 'modules/redux/selectors/get'
import { MEDIA_GALLERY_KEY, MEDIA_GALLERY_PATH } from 'modules/media-gallery/redux/state'

/**
 * @param state
 * @returns {Object}
 */
const getShouldUpdateMediaSelect = state => {
  const path = MEDIA_GALLERY_PATH[MEDIA_GALLERY_KEY.SHOULD_UPDATE_MEDIA]
  return getReduxSelector(path)(state)
}

export default getShouldUpdateMediaSelect
